<template>
	<div>
		<template v-if="awards.length">
			<card v-for="(award, key) in awards" :key="'award-' + key" xs-tile sm-tile>
				<card-text>
					<award :award="award"/>
				</card-text>
			</card>
		</template>
		<missing-info v-else :text="$t('missing.event.awards')" shadow/>
	</div>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$api, $web, $date} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.Awards)) {
	await navigateTo($web('events.show', route.params.event));
}

const {data: awards} = await useApiFetch($api('events.awards.index', eventStore.event.id), {
	guest: true,
	params: {
		ts: eventStore.event.cache_buster,
		relations: ['participationClasses']
	}
})

useMeta({
	title: eventStore.buildPageTitle(t('view.events.awards.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.awards.index.description', {event: eventStore.event.display_name})
})

</script>

